import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
var drawerBleeding = 56;
export var Puller = function Puller() {
  return React.createElement(Box, {
    sx: {
      width: 44,
      height: 4,
      backgroundColor: '#A7ADB0',
      borderRadius: 3,
      position: 'absolute',
      top: 8,
      left: 'calc(50% - 15px)'
    }
  });
};

var TAGPhoneDrawer = function TAGPhoneDrawer(props) {
  // const { window } = props
  // This is used only for the example
  // const container = document.body // = window !== undefined ? () => window().document.body :
  // const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)
  return React.createElement(SwipeableDrawer, _objectSpread(_objectSpread({}, props), {}, {
    // container={container}
    anchor: "bottom",
    open: props.open,
    onClose: props.onClose,
    onOpen: props.onOpen,
    swipeAreaWidth: drawerBleeding,
    disableSwipeToOpen: false,
    // disableBackdropTransition={!iOS}
    // disableDiscovery={iOS}
    ModalProps: {
      keepMounted: true
    },
    PaperProps: {
      square: false,
      sx: {
        maxHeight: '80%',
        borderRadius: '10px 10px 0px 0px',
        overflow: 'visible'
      }
    },
    sx: [props.sx]
  }), React.createElement(Puller, null), React.createElement(Box, {
    id: "DrawerContent",
    sx: {
      marginTop: '22px',
      overflow: 'auto'
    }
  }, props.children));
};

export default TAGPhoneDrawer;